import React, { useState, useEffect, useRef } from "react";
import SlideRuler from "slide-ruler";
import "./Ruler.css";

const WeightRuler = ({ from, onWeightChange }) => {
  const slideRulerRef = useRef(null);
  const [selectedValue, setSelectedValue] = useState(15);

  useEffect(() => {
    const savedWeight = JSON.parse(localStorage.getItem("weight")) || "";
    if (savedWeight !== "" && from === "weight") {
      setSelectedValue(savedWeight);
    } 
    const handleValue = (value) => {
      setSelectedValue(value);
      onWeightChange(value);
    };

    if (slideRulerRef.current) {
      new SlideRuler({
        el: slideRulerRef.current,
        maxValue: from === "report" ? 150 : 499,
        heightDigit: 35,
        heightDecimal: 55,
        minValue: 0,
        currentValue: selectedValue,
        lineWidth: 2,
        colorDecimal: "#fff",
        colorDigit: "#fff",
        fontColor: "#fff",
        divide: 15,
        fontMarginTop: 62,
        handleValue: handleValue,
      });
    }
  }, []);

  return (
    <div className="rulerSelector centeredFlex">
      {selectedValue !== null && (
        <div className="rulerValueWrapper centeredFlex">
          <span className="rulerValue">{selectedValue}</span>
          <span className="rulerUnit">kg</span>
        </div>
      )}
      <div ref={slideRulerRef}></div>
    </div>
  );
};

export default WeightRuler;
